export interface IScenario {
  name: string,
  values: Object
}

export const scenarios: IScenario[] = [
  {
    name: 'Base Case',
    values: {
      p1: 0,
      p2: 0.9,
      p3: 3,
      p4: 10,
      p5: 10,
      p6: 0.0015,
      p7: 0.2
    },
  },
  {
    name: 'Measles',
    values: {
      p1: 0.6,
      p2: 0.99,
      p3: 10,
      p4: 7,
      p5: 10,
      p6: 0.00214,
      p7: 0.9
    },
  },
  {
    name: 'Influenza',
    values: {
      p1: 0.88,
      p2: 0.67,
      p3: 3,
      p4: 10,
      p5: 10,
      p6: 0.00015,
      p7: 0.25
    },
  },
]
